<template>
  <div class="w-100 mt-2">

    <DropZones
      @drop.prevent="drop"
      @change="selectedFile"
      :fileInfo="{
        title,
        accept: (this.is_upgrade&&this.upgrade_type==1)?title1:title2,
        limit: ' 50M',
      }"
      ID="dropzoneFiles"
      :accept="'.ppt,.pptx,.pdf,.xls,.xlsx,.doc,.docx,.png,.jpeg,.jpg,.mp4,.mov,.glb'"
    />
    <h4
      class="card-title mb-1 mt-3 flex-grow-1"
      v-show="
               (showfiles['before']&&showfiles['before'].length) ||
                (showfiles['after']&&showfiles['after'].length) ||
                (showfiles['actual']&&showfiles['actual'].length)
              "
    >
      {{ this.$t("page.files_upload.uploaded_data") }}
    </h4>
    <div
      class="border border-solid rounded p-3"
      v-show="
               (showfiles['before']&&showfiles['before'].length) ||
                (showfiles['after']&&showfiles['after'].length) ||
                (showfiles['actual']&&showfiles['actual'].length)
              "
    >
      <div v-show="showfiles['actual']&&showfiles['actual'].length"  >
        <div>
          <div class="border-primary fs-14 material-title">
            {{  $t("Data Streaming") }}
          </div>
        </div>
        <div class="product-img-slider sticky-side-div ps-5 pe-5">
          <SwiperTool
              :swiperInfo="{
              type: 'actual',
              page: 'assetform',
              spaceBetween: 10,
              slidesPerView: 15,
              actionsClass: [
                { name: 'ri-eye-fill', action: 'view' },
                { name: 'ri-download-2-fill', action: 'download' },
                { name: 'ri-delete-bin-5-fill', action: 'delete' },
              ],
            }"
              :list="showfiles['actual']"
              @deleteFile="deleteFile"
          >
          </SwiperTool>
        </div>
      </div>
      <div v-show="showfiles['before']&&showfiles['before'].length" class="mt-4">
        <div>
          <div class="border-primary fs-14 material-title">
            {{ $t("技改前") }}
          </div>
        </div>
        <div class="product-img-slider sticky-side-div ps-5 pe-5">
          <SwiperTool
              :swiperInfo="{
              type: 'before',
              page: 'assetform',
              spaceBetween: 10,
              slidesPerView: 15,
              actionsClass: [
                { name: 'ri-eye-fill', action: 'view' },
                { name: 'ri-download-2-fill', action: 'download' },
                { name: 'ri-delete-bin-5-fill', action: 'delete' },
              ],
            }"
              :list="showfiles['before']"
              @deleteFile="deleteFile"
          >
          </SwiperTool>
        </div>
      </div>
      <div v-show="showfiles['after']&&showfiles['after'].length" class="mt-4">
        <div>
          <div class="border-primary fs-14 material-title">
            {{ $t("技改后") }}
          </div>
        </div>
        <div class="product-img-slider sticky-side-div ps-5 pe-5">
          <SwiperTool
              :swiperInfo="{
              type: 'after',
              page: 'assetform',
              spaceBetween: 10,
              slidesPerView: 15,
              actionsClass: [
                { name: 'ri-eye-fill', action: 'view' },
                { name: 'ri-download-2-fill', action: 'download' },
                { name: 'ri-delete-bin-5-fill', action: 'delete' },
              ],
            }"
              :list="showfiles['after']"
              @deleteFile="deleteFile"
          >
          </SwiperTool>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import DropZones from "@/components/widgets/dropZone.vue";
import { v4 as uuidv4 } from "uuid";
import SwiperTool from "@/components/swiperTool.vue";
import axios from "axios";
import { getUploadFileSign, getUploadFileDetail } from "@/service";
import { imageCompress } from "@/utils/common.js";

export default {
  emits: ["update:energy","energyChange", "handleAlert"],
  props: {
    energy:{
        type:Object,
      default:()=>{
        return {files:{}}
      }
    },
    is_upgrade:{
      type: Boolean,
      default: () => {
        return false;
      },
    },
    upgrade_type:{
      type: Number,
      default: () => {
        return 1;
      },
    }
  },
  setup() {},
  data() {
    return {
      fileMaxSize: 1024 * 1024 * 50,
      title:this.$t("点击上传历史电流数据"),
      title1:this.$t("技改前数据请上传一个自然年数据"),
      title2:this.$t("建议按照年度上传历史电流数据进行分析对比"),
    };
  },
  components: {
    DropZones,
    SwiperTool,
  },
  mounted() {
    console.log(this.upgrade_type)

  },

  computed:{
    showfiles(){
      return this.is_upgrade?{before:this.energy.files.before&&this.energy.files.before||[],after:this.energy.files.after&&this.energy.files.after||[]}:{actual:this.energy.files.actual&&this.energy.files.actual||[]}
    },

  },
  methods: {

    checkFile(file) {
      let name = /^device\//.test(file.name)
        ? file.name.substring(44)
        : file.name;
      // let suffix = name.substring(name.lastIndexOf("."));
      let type = this.is_upgrade?(this.upgrade_type==1?"before":"after"):"actual"
      console.log(this.showfiles)
      let i = this.showfiles[type].findIndex((item) => {
        let object_name = /^device\//.test(item.object_name)
          ? item.object_name.substring(44)
          : item.object_name;
        return object_name === name;
      });
      return i == -1;
    },
    async selectedFile() {
      console.log(1,this.showfiles)

      let dropzoneFile = document.getElementById("dropzoneFiles").files[0];
      if (!dropzoneFile) return;
      // if (dropzoneFile.size > this.fileMaxSize) {
      //   this.$emit(
      //     "handleAlert",
      //     "danger",
      //     this.$t("page.files_upload.file_size_cannot_exceed_50M"),
      //     "ri-error-warning-line"
      //   );
      //   document.getElementById("dropzoneFiles").value = "";
      //   return;
      // }
      // if (!this.checkFile(dropzoneFile)) {
      //   this.$emit(
      //     "handleAlert",
      //     "danger",
      //     this.$t("page.files_upload.same_name_file"),
      //     "ri-error-warning-line"
      //   );
      //   document.getElementById("dropzoneFiles").value = "";
      //   return;
      // }
      let suffix = dropzoneFile.name.substring(
        dropzoneFile.name.lastIndexOf(".")
      );
      console.log(suffix,dropzoneFile)

      if (/\.(png|jpeg|jpg)$/.test(suffix)) {
        let file = await imageCompress(dropzoneFile);
        this.uploadFileSign(file);
      } else {
        this.uploadFileSign(dropzoneFile);
      }
    },
    async drop(e) {
      console.log(2,this.showfiles)

      let dropzoneFile = e.dataTransfer.files[0];
      if (!dropzoneFile) return;

      if (dropzoneFile.size > this.fileMaxSize) {
        this.$emit(
          "handleAlert",
          "danger",
          this.$t("page.files_upload.file_size_cannot_exceed_50M"),
          "ri-error-warning-line"
        );
        document.getElementById("dropzoneFiles").value = "";
        return;
      }

      if (!this.checkFile(dropzoneFile)) {
        this.$emit(
          "handleAlert",
          "danger",
          this.$t("page.files_upload.same_name_file"),
          "ri-error-warning-line"
        );
        document.getElementById("dropzoneFiles").value = "";
        return;
      }
      let suffix = dropzoneFile.name.substring(
        dropzoneFile.name.lastIndexOf(".")
      );
      if (/\.(png|jpeg|jpg)$/.test(suffix)) {
        let file = await imageCompress(dropzoneFile);
        this.uploadFileSign(file);
      } else {
        this.uploadFileSign(dropzoneFile);
      }
    },
    deleteFile(i,type) {
      Swal.fire(this.$t("base.delete_success"));
      this.showfiles[type].splice(i, 1);
    },
    uploadFileSign(file) {
      Swal.fire({
        title: this.$t("page.files_upload.uploading"),
        showConfirmButton: false,
      });
      Swal.showLoading();
      let filename = file.name;
      let objectName = `device/${uuidv4()}/${filename}`;
      let params = {
        object: objectName,
        method: "upload",
      };
      getUploadFileSign(params)
        .then((res) => {
          if (res && res.payload) {
            axios
              .put(res.payload.signedUrl, file, {
                headers: { "Content-Type": file.type },
              })
              .then(() => {
                let params = {
                  object: objectName,
                };
                getUploadFileDetail(params).then((resDetail) => {
                  if (resDetail && resDetail.payload) {
                    let detail = resDetail.payload;
                    let info = {
                      url: detail.url,
                      etag: detail.etag,
                      size: detail.size,
                      content_type: detail.contentType,
                      object_name: detail.objectName,
                      last_modified: detail.lastModified,
                    };
                    // let suffix = info.object_name.substring(
                    //   info.object_name.lastIndexOf(".")
                    // );
                    this.showfiles[this.is_upgrade?(this.upgrade_type==1?"before":"after"):"actual"].push(info);
                    this.$emit("energyChange",  this.showfiles);
                    document.getElementById("dropzoneFiles").value = "";
                    Swal.close();
                    this.$emit(
                      "handleAlert",
                      "success",
                      this.$t("base.upload_success"),
                      "ri-check-double-line"
                    );
                  }
                });
              })
              .catch(() => {
                Swal.close();
                this.$emit(
                  "handleAlert",
                  "danger",
                  this.$t("base.delete_failed_please_try_again"),
                  "ri-error-warning-line"
                );
                document.getElementById("dropzoneFiles").value = "";
              });
          }
        })
        .catch(() => {
          Swal.close();
          this.$emit(
            "handleAlert",
            "danger",
            this.$t("base.delete_failed_please_try_again"),
            "ri-error-warning-line"
          );
          document.getElementById("dropzoneFiles").value = "";
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.material-title {
  border-left: 3px solid;
  padding-left: 8px;
  height: 22px;
  line-height: 22px;
}
</style>
